import invoice from '@/pages/settlementManage/invoice'
import layout from '@/components/layout/layout'
const settlementRouter =
  {
    path: '/settlementManage',
    component: layout,
    meta: {roles: ['r4gys'], title: '发票管理', icon: 'icon-guanlibaobiaoon'},
    children: [
      {
        path: '/settlementManage/invoice',
        component: invoice,
        name: 'dataReport',
        meta: {roles: ['r4gys',], title: '发票管理'}
      },
    ]
  }
export default settlementRouter



// WEBPACK FOOTER //
// ./src/router/modules/settlementRouter.js